const SuccessIcon = () => (
  <svg width="256" height="256" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_348_971)">
      <circle cx="128" cy="121" r="82" stroke="#E78850" stroke-width="8" />
    </g>
    <path
      d="M105.636 123.795L121.477 139.636L153.159 107.955"
      stroke="#E78850"
      stroke-width="8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_348_971"
        x="0"
        y="0"
        width="256"
        height="256"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="7" />
        <feGaussianBlur stdDeviation="21" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.291146 0 0 0 0 0.749938 0 0 0 0 0.8125 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_348_971" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_348_971" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default SuccessIcon;
